import React, { Component } from 'react';
import { sendJson,getURL } from '../backend/Backend';
import '../css/style.css';
import './Home.css';
import './App.css';
import {Card} from 'react-bootstrap';
import { translate } from "react-i18next";
import AuthenticationService from '../backend/AuthenticationService';





class Profile extends Component {

  constructor(props) {
    super(props);

    //userService.logout();

    this.state = {
        name: '',
        email:'',
        id:'',
        submitted: false,
        loading: false,
        error: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async componentDidMount() {
    let email = AuthenticationService.getLoggedInUserName();
    if(!email){
        return;
    }

    let searchId= '0';
    const response = await fetch(getURL('users/search/' + searchId+'/'+email ))

    const json = await response.json();
    let oldState = this.state;

    this.setState({ ...oldState,
        id:json.id,
        name: json.name,
        email: json.email
     });
  }

    handleChange(e) {
        const { name, value } = e.target;
        let oldState = this.state;
        this.setState({
          ...oldState, 
          [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();
        let oldState = this.state;
        this.setState({...oldState, 
          submitted: true });
        const { name, email} = this.state;
     

        // stop here if form is invalid
        if (!email || !name ) {
            return;
        }
        
        oldState = this.state;
        this.setState({...oldState, 
          loading: true });
        this.setState({ loading: true });
        this.onUserUpdate(this.state.id, name, email);
        
    }

   
    onUserUpdate(id, name, email) {
        let user = {id:id, 'name':name, 'email':email, 'failedCount':-1};
        console.log("initialize users...."+user.email)
        sendJson('put', 'users/update', user).then(
            received => {
              //this.props.onAdd(received); 
              if(received){
                  console.log("user saved  :-)");
                  let oldState = this.state;
                  this.setState({...oldState, loading: false });
              }
            });
    }

  render() {
    const { t } = this.props;
    const { name, email, submitted, loading, error } = this.state;
    return (
        <div className="col-md-6 mt-5">

            <Card>
            <Card.Header className="text-primary">{t("myProfile")}</Card.Header>
            <Card.Body>
                <Card.Text>
                <form name="form" onSubmit={this.handleSubmit}>
                <div className={'form-group' }>
                    <input type="text" className="form-control" name="name" value={name} onChange={this.handleChange} 
                     placeholder={t("OptionalName")} />
                </div>
                <div className={'form-group' + (submitted && !email ? ' has-error' : '')}>
                    <input type="text" className="form-control" name="email" value={email} onChange={this.handleChange} 
                     placeholder={t("regEmail")} readOnly/>
                    {submitted && !email &&
                        <div className="text-danger">{t("emailWarning")}</div>
                    }
                </div>
               
                <div className="form-group">
                    <button className="btn btn-primary float-right" disabled={loading}>{t("speichern")}</button>
                    {loading &&
                        <img alt="loading..." src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    }
                </div>
                {error &&
                    <div className={'alert alert-danger'}>{error}</div>
                }
               

            </form>
                </Card.Text>
            </Card.Body>
            </Card>


            
        </div>
    );
}

}


export default translate("translations")(Profile);

